import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createFuelingService } from '../../api/fueling-service.ts';
import { CreateFuelingServiceRequest } from '../../api/requests/fueling-service-request.ts';

export default function useCreateFuelingService(): UseMutationResult<
  Awaited<ReturnType<typeof createFuelingService>>,
  Error,
  CreateFuelingServiceRequest
> {
  return useMutation({
    mutationFn: createFuelingService,
  });
}
